import axios, { AxiosInstance } from "axios";
import { getClientRef } from "./clientRef";
import { fetchTenantId, getRootDomain } from "./tenantResolver";
export * from "./request";

const endpointUrl = process.env.REACT_APP_ENDPOINT_URL;
 if (!endpointUrl) {
   throw new Error("Missing REACT_APP_ENDPOINT_URL (API base URL). Configure it in environment/secrets.");
 }
 export const baseURL = endpointUrl;


const basicAuth = process.env.REACT_APP_AUTH;
 if (!basicAuth) {
   throw new Error("Missing REACT_APP_AUTH (Basic authentication credentials). Configure it in environment/secrets.");
 }
const clientXRef = process.env.REACT_APP_X_REQ_REF;
 if (!clientXRef) {
   throw new Error("Missing REACT_APP_X_REQ_REF (Client reference). Configure it in environment/secrets.");
 }
const tenantDomainHeader = "X-Tenant-Domain";

const getTenantDomain = () => {
  if (typeof window === "undefined") return "";
  return getRootDomain(window.location.hostname);
};

export const headers = {
  Accept: "application/json, text/plain, */*",
  "Content-Type": "application/json",
  Authorization: basicAuth,
  "X-Client-Ref": getClientRef(),
  "X-Request-Ref": clientXRef,
  [tenantDomainHeader]: getTenantDomain(),
}

const axiosInstance: AxiosInstance = axios.create({
  baseURL,
  headers
});

axiosInstance.interceptors.request.use(async (config) => {
  config.headers = config.headers || {};
  config.headers[tenantDomainHeader] = getTenantDomain();

  const tenantId = await fetchTenantId();
  if (tenantId) {
    config.headers["X-Tenant-Id"] = tenantId;
  }

  return config;
});

export default axiosInstance;
